(() => {
  const SF_TOKEN = "{{ settings.sf_token }}";
  const ENDPOINT = "https://{{ shop.permanent_domain }}/api/2024-10/graphql.json";

  async function resolveVariant(productGID, selectedOptions) {
    const query = `
      query VariantByOptions($id: ID!, $opts: [SelectedOptionInput!]!) {
        product(id: $id) {
          variantBySelectedOptions(selectedOptions: $opts) {
            id
            availableForSale
            price { amount currencyCode }
            compareAtPrice { amount currencyCode }
            image { url altText }
          }
        }
      }`;
    const res = await fetch(ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": SF_TOKEN
      },
      body: JSON.stringify({ query, variables: { id: productGID, opts: selectedOptions } })
    });
    const json = await res.json();
    return json?.data?.product?.variantBySelectedOptions || null;
  }

  function currentSelections() {
    return [...document.querySelectorAll(".VariantRow")].map(row => {
      const name = row.dataset.optionName;
      const selected = row.querySelector(".VariantPill.is-selected, .VariantPill[aria-pressed='true']");
      return selected ? { name, value: selected.dataset.optionValue } : null;
    }).filter(Boolean);
  }

  async function applyResolvedVariant(v) {
    if (!v) return;

    // 1) set the real variant id on the add-to-cart input
    const varId = v.id.split("/").pop();
    document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(i => i.value = varId);

    // 2) price update (use your theme’s hook if it has one)
    const priceEl = document.querySelector("[data-product-price]");
    if (priceEl && v.price) priceEl.textContent = v.price.amount;

    // 3) image swap (optional, light)
    if (v.image?.url) {
      const feat = document.querySelector("[data-featured-media]");
      if (feat) feat.src = v.image.url;
    }

    // 4) availability -> toggle class you already style
    document.documentElement.classList.toggle("variant-unavailable", !v.availableForSale);

    // 5) keep deep link stable
    const u = new URL(location.href);
    u.searchParams.set("variant", varId);
    history.replaceState({}, "", u.toString());
  }

  // Monkey-patch: override theme’s local “find variant” with server truth
  async function onSelectionChanged() {
    const productGID = document.documentElement.dataset.productGid;
    if (!productGID) return;
    const opts = currentSelections();
    if (opts.length === 0) return;
    const v = await resolveVariant(productGID, opts);
    await applyResolvedVariant(v);
  }

  // Make ALL pills clickable (don’t pre-disable based on old map)
  document.addEventListener("click", e => {
    const pill = e.target.closest(".VariantPill");
    if (!pill) return;
    const row = pill.closest(".VariantRow");
    row.querySelectorAll(".VariantPill").forEach(b => {
      const sel = b === pill;
      b.classList.toggle("is-selected", sel);
      b.setAttribute("aria-pressed", sel ? "true" : "false");
      // do NOT hard-disable here; availability comes from Shopify after resolve
    });
    onSelectionChanged();
  });

  // Initial run (handles ?variant or defaults)
  window.addEventListener("DOMContentLoaded", onSelectionChanged);
})();
